module.exports = __webpack_public_path__ + "img/foot.f2b525b5.png";